module.exports = __webpack_public_path__ + "static/media/icon-paint.893369af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-paint.svg
// module id = 1227
// module chunks = 19